const getCurrentDate = (format, addHour = 0) => {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var date = now.getDate()
  var day = now.getDay()
  var hour = now.getHours()
  var minu = now.getMinutes()
  var sec = now.getSeconds()
  month = month + 1
  if (month < 10) month = '0' + month
  if (date < 10) date = '0' + date
  if (hour < 10) hour = '0' + hour
  if (minu < 10) minu = '0' + minu
  if (sec < 10) sec = '0' + sec
  var time = ''
  if (format === 1) {
    time = year + '-' + month + '-' + date
  } else if (format === 2) {
    time = hour
  } else if (format === 3) {
    time = hour + addHour
  }
  return time
}

const getWhenDate = (start, addNum, format = 0) => {
  var s, thatDay, y, m, d, endDate
  s = Math.round((start + addNum * 24 * 60 * 60 * 1000) / 1000)
  thatDay = new Date(s * 1000)
  y = thatDay.getFullYear()
  m = thatDay.getMonth() + 1
  d = thatDay.getDate()
  if (format === 1) {
    return s
  }
  endDate = m + '月' + d + '日'
  if (addNum === 0) {
    endDate += '（今天）'
  } else {
    endDate += dayFormat(thatDay.getDay())
  }
  return endDate
}

const dayFormat = (value) => {
  let day = parseInt(value)
  switch (day) {
    case 0:
      day = '（周日）'
      break
    case 1:
      day = '（周一）'
      break
    case 2:
      day = '（周二）'
      break
    case 3:
      day = '（周三）'
      break
    case 4:
      day = '（周四）'
      break
    case 5:
      day = '（周五）'
      break
    case 6:
      day = '（周六）'
      break
  }
  return day
}

export {
  getWhenDate,
  getCurrentDate,
  dayFormat

}



// WEBPACK FOOTER //
// ./src/assets/js/timeFormat.js